import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'BBQ Pork Rub',
  source: 'https://www.seriouseats.com/sous-vide-pork-ribs-recipe-food-lab',
  totalTime: time(0, 5),
  servings: 4,
  tags: { type: 'sauce' },
  ingredients: [
    { name: 'paprika', quantity: '1/3', unit: 'cup' },
    { name: 'dark brown sugar', quantity: '1/3', unit: 'cup' },
    { name: 'kosher salt', quantity: '1/4', unit: 'cup' },
    { name: 'whole yellow mustard seed', quantity: '2', unit: 'tbsp' },
    { name: 'black pepper', quantity: '1', unit: 'tsp' },
    { name: 'granulated garlic powder', quantity: '2', unit: 'tbsp' },
    { name: 'dried oregano', quantity: '1', unit: 'tbsp' },
    { name: 'whole coriander seed', quantity: '1', unit: 'tbsp' },
    { name: 'red pepper flakes', quantity: '1', unit: 'tsp' },
  ],
  directions: [
    {
      title: 'Grind spices',
      bullets: [
        "In spice grinder, combine {paprika}, {dark brown sugar}, {kosher salt}, {whole yellow mustard seed}, {black pepper}, {granulated garlic powder}, {dried oregano}, {whole coriander seed} & {red pepper flakes}",
        "Grind to fine powder",
      ],
    },
  ],
};

export default recipe;
